import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import { fetchAppointmentView } from 'slices/appointmentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import toast from 'react-hot-toast';
import { setActionAssign } from 'slices/actionButtonSlice';
import CancelModal from 'components/appointment/CancelModal';
import DonotCover from 'components/appointment/DonotCover';
import RescheduleModal from 'components/appointment/RescheduleModal';
import { fetchAppointmentLogs } from 'slices/appointmentSlice';
import LogsTable from './LogsTable';
import { setAddAppointmentPopup } from 'slices/appointmentSlice';
import { appointmentsSelector } from 'slices/appointmentSlice';
import { closeAppointmentPopup } from 'slices/appointmentSlice';
import { removeAppointment } from 'slices/appointmentSlice';
import Swal from 'sweetalert2';
import SelectInterpreterModal from 'components/common/SelectInterpreterModal';
import CouldNotCover from 'components/appointment/CouldNotCover';
import FullPageLoader from 'components/common/FullPageLoader';
import { CheckinCheckoutAdjustmentModal } from 'components/appointment/checkinCheckoutAdjustment';
import { usePermissions } from 'layouts/Admin';
import AddPatient from 'components/appointment/AddPatient';
import ApprovalModal from 'components/appointment/ApprovalModal';
import useTimeZoneClock from 'hooks/useTimeZoneClock';
import moment from 'moment';
import ViewTable from './ViewTable';

const AppointmentView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const { checkPermission } = usePermissions()
    const dispatch = useDispatch();
    const [item, setItem] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [logs, setLogs] = React.useState([]);
    const [cancelModal, setCancelModal] = React.useState(false);
    const [donotCover, setDonotCover] = React.useState(false);
    const [addPatient, setAddPatient] = React.useState(false);
    const [couldNotCover, setCouldNotCover] = React.useState(false);
    const [approval, setApproval] = React.useState(false);
    const [assignInterpreter, setAssignInterpreter] = React.useState(false);
    const [rescheduleModal, setRescheduleModal] = React.useState(false);
    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);

    const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);


    const callViewApi = async () => {
        const callBack = (success, message, data) => {
            setLoading(false);
            if (success) {
                setItem(data)
                // console.log(data)
            }
            else {
                console.log(message)
            }
            // setItem()
        }

        dispatch(fetchAppointmentView(id, callBack))
    };

    // React.useEffect(() => {
    // if (item?.vendor_approval_status === 1 && checkPermission('Approve Vendor Request')) {
    //     new Swal({
    //     title: "Vendor Approval Request",
    //     text: "Interpreter has requested to send this appointment to vendor. Do you approve?",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonText: "Yes, Approve",
    //     cancelButtonText: "Decline",
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     }).then((result) => {
    //     if (result.isConfirmed) {
    //         handleSubmit(
    //         { action: "approve" },
    //         "vendor-approval",
    //         () => console.log("Vendor request approved successfully!")
    //         );
    //     } else if (result.dismiss === Swal.DismissReason.cancel) {
    //         handleSubmit(
    //         { action: "decline" },
    //         "vendor-approval",
    //         () => console.log("Vendor request declined successfully!")
    //         );
    //     }
    //     });
    // }
    // }, [item]);
    
    const fetchLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setLogs(data)
                // console.log(data)
            }
            else {
                console.log(message)
            }
            // setLogs()
        }
        dispatch(fetchAppointmentLogs(id, callBack))
    }

    React.useEffect(() => {
        setLoading(true)
        callViewApi();
        fetchLogs();

    }, [id]);

    const handleCancel = () => {
        setCancelModal(true);
    };
    const handleCloseCancel = () => {
        setCancelModal(false);
    };
    const handleDonotCover = () => {
        setDonotCover(true);
    };
    const handleCloseDonotCover = () => {
        setDonotCover(false);
    };

    const handleAddPatient = () => {
        setAddPatient(true);
    };
    const handleCloseAddPatient = () => {
        setAddPatient(false);
    };

    const handleApproval = () => {
        setApproval(true);
    };
    const handleCloseApproval = () => {
        setApproval(false);
    };

    const handleCouldNotCover = () => {
        setCouldNotCover(true);
    };
    const handleCloseCouldNotCover = () => {
        setCouldNotCover(false);
    };
    const handleReschedule = () => {
        setRescheduleModal(true);
    };
    const handleCloseReschedule = () => {
        setRescheduleModal(false);
    };
    const handleAssignInterpreter = () => {
        setAssignInterpreter(true);
    };
    const handleCloseAssignInterpreter = () => {
        setAssignInterpreter(false);
    };
    const handleOpenCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(true);
    };
    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };
    const handleEditAppointmentPopUp = () => {
        dispatch(
            setAddAppointmentPopup({
                show: true,
                popupType: "edit",
                item,
            })
        )
    };
    const handleCopyAppointmentPopUp = () => {
        dispatch(
            setAddAppointmentPopup({
                show: true,
                popupType: "copy",
                item,
            })
        )
    };
    const handleCloseEditApptPopup = () => {
        dispatch(closeAppointmentPopup())
    }

    const handleSubmit = (data, end_point, callBack) => {
        setLoading(true)
        const submitCallback = (success, message) => {
            callBack && callBack()
            if (success) {
                handleCloseCancel();
                handleCloseDonotCover();
                handleCloseCouldNotCover();
                handleCloseReschedule();
                handleCloseAssignInterpreter();
                handleCloseEditApptPopup()
                handleCloseCheckinCheckoutModal()
                handleCloseAddPatient();
                handleCloseApproval();
                callViewApi();
                fetchLogs()
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false)
                // scheduleDetailModal?.show && openModal()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
                setLoading(false)
            }
        }
        if (end_point === "assign-vendor") {
            new Swal({
                title: "Are you sure you want to send this appointment to vendor?",
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, confirm!",
            }).then((result) => {
                if (result.isConfirmed) {
                    setLoading(true);
                    dispatch(
                        setActionAssign(
                            id,
                            data,
                            end_point,
                            submitCallback
                        )
                    );
                }
            });
        } else {
            setLoading(true);
            dispatch(
                setActionAssign(
                    id,
                    data,
                    end_point,
                    submitCallback
                )
            )
        }
    }

    const editFormSubmitCallback = () => {
        callViewApi()
    }

    const handleRemove = () => {
        const callBack = (success, message) => {
            if (success) {
                new Swal({
                    title: message,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                })

                navigate('/', { replace: true });



            }
            else {

                new Swal({
                    title: message,
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false
                })


            }
        }
        new Swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    dispatch(
                        removeAppointment(
                            id,
                            callBack
                        )
                    )
                }
            })




    }

    const navigateToInviteInterpreter = () => {
        // window.location.href = `/invite-interpreter/${id}`;
        navigate(`/appointments/invite-interpreter/${id}`);
    }
    const mileageCheck = (val) => {
        return item?.appointment_details?.[val];
    }
    const rawDatetime = item?.date +" "+ item?.start_time;

    const formattedDate = moment(rawDatetime, 'YYYY-MM-DD HH:mm:ss').format('MMM D, YYYY HH:mm:ss');

    console.log("itemcheck", item)
    console.log('Vendor ID:', item?.vendor_id);
    return (
        <div className="content" style={{}}>
            {loading && <FullPageLoader />}
            {/* <did */}
            <div className="row_main_head bg-primary-secondaryCard">
                <h2 className={`main_heading main_heading1`}>View Appointment # {item?.appid}</h2>
               
            </div>
            {item?.vendor_approval_status === 1 && checkPermission('Approve Vendor Request') && (
                <div className="waiting d-flex justify-content-between align-items-center flex-wrap mt-3 p-3 rounded" style={{ backgroundColor: '#ffce4273' }}>
                    <h3 className="mb-2 mb-md-0">
                    Interpreter {item?.interpreter
                    ? `${item.interpreter.first_name ?? ""} ${item.interpreter.last_name ?? ""}`
                    : "N/A"} has requested admin approval to send this appointment to Excel.
                    </h3>
                    <div className="d-flex gap-2">
                    <SubmitButton
                        buttonType="button"
                        className="green"
                        btnText="Approve"
                        handleSubmit={() =>
                        handleSubmit(
                            { action: "approve" },
                            "vendor-approval",
                            () => console.log("Excel request approved successfully!")
                        )
                        }
                    />
                    <SubmitButton
                        buttonType="button"
                        className="tomatoRed"
                        btnText="Decline"
                        handleSubmit={() =>
                        handleSubmit(
                            { action: "decline" },
                            "vendor-approval",
                            () => console.log("Excel request declined successfully!")
                        )
                        }
                    />
                    </div>
                </div>
                )}
            <div className="row_main_head bg-light-secondaryCard mt-3">
                {item?.type !== "2" ?
                <h2 className={`main_heading2 d-flex align-items-center flex-wrap gap-1`} toLowerCase={'text-lowercase'}>Date & Time <span className="dateTime">{formattedDate}</span></h2>
                : <h2></h2>
                }
                <div className=''>
                    <div className='text-transform-capitalize main_heading2  flex flex-wrap gap-2  justify-content-end' style={{display: 'flex', flexWrap: 'wrap', gap: '5px'}} >
                   {item?.status && <span className="appointmentType">{item?.status}</span> }
                    <span className="appLanguage">{item?.language?.name || item?.language_other}</span>
                    </div>
                </div>
            </div>
            <div className="card_table view_table_custom">
                {(mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == null) ?
                    <div className='row_main_head align-items-center softAlert waiting'>
                        <h3>The vendor has requested extra mileage</h3>
                        {checkPermission('Extra Mileage') &&
                            <SubmitButton buttonType="button" className={'green'} btnText="View Request" handleSubmit={handleApproval} />
                        }
                    </div>
                    :
                    (mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == 1) ?
                        <div className='softAlert approved'>
                            <h3>The extra mileage request for this appointment have been approved.</h3>
                        </div>
                        : (mileageCheck('extra_mileage') && mileageCheck('extra_mileage_request') == 0) ?
                            <div className='softAlert rejected'>
                                <h3>The extra mileage request for this appointment have been rejected.</h3>
                            </div>
                            :
                            ''
                }
                
                {/* <div className="row_main_head">
                    <h2 className={`main_heading`}>View Appointment # {item?.appid}</h2>
                    <div className='mb-3'>
                        <div className='text-transform-capitalize main_heading' >
                            Status : {item?.status}
                        </div>
                    </div>
                </div> */}

                <div className='row-primary flex-wrap'>
                    {item?.status === 'completed' ? (
                        checkPermission('Check-in/Check-out') && (
                            <SubmitButton buttonType="button" className="Cancle_button"
                                btnText="Checkin / checkout"
                                data-bs-toggle="modal"
                                data-bs-target="#checkinCheckoutAdjustmentModal" handleSubmit={handleOpenCheckinCheckoutModal} />
                        )
                    ) : (
                        <>
                            {/* {checkPermission('Copy Appointment') &&
                                <SubmitButton buttonType="button" className={'lightPurple'} btnText="Copy" handleSubmit={handleCopyAppointmentPopUp}
                                />
                            } */}
                            {checkPermission('Assign Appointment') && (
                                <>
                                    {(item?.status === 'assigned' || item?.status === 'pending' || item?.status === 'available') ? (
                                        <SubmitButton buttonType="button" className={'green'} btnText={item?.status === 'assigned' ? 'Reassign' : 'Assign'} handleSubmit={handleAssignInterpreter} />
                                    ) : null}
                                </>
                            )}
                            {/* {checkPermission('Edit Appointments') &&
                                <SubmitButton buttonType="button" className={'lightGrey'} btnText="Edit" handleSubmit={handleEditAppointmentPopUp}
                                />
                            } */}
                            {checkPermission('Reschedule Appointment') && !item?.vendor_id && (
                                <SubmitButton buttonType="button" className={'lightBlue'} btnText="Reschedule" handleSubmit={handleReschedule} />
                            )}
                            {/* {(checkPermission('Donot Cover') && item?.status !== "DNC") && <SubmitButton buttonType="button" btnText="Do Not Cover" className="yellow" handleSubmit={handleDonotCover} />} */}
                            {/* {(checkPermission('Could Not Cover') && item?.status !== "CNC") && <SubmitButton buttonType="button" btnText="Could Not Cover" className="yellow" handleSubmit={handleCouldNotCover} />} */}
                            {/* {(checkPermission('Cancel Appointment') && item?.status !== "cancelled") && <SubmitButton buttonType="button" className={'tomatoRed'} btnText="Cancel" handleSubmit={handleCancel} />} */}
                            {checkPermission('Check-in/Check-out') && (
                                <SubmitButton buttonType="button" className="Cancle_button"
                                    btnText="Checkin / checkout"
                                    data-bs-toggle="modal"
                                    data-bs-target="#checkinCheckoutAdjustmentModal" handleSubmit={handleOpenCheckinCheckoutModal} />
                            )}
                            {/* {(item?.status == "declined") && !item?.vendor_id && (
                                <SubmitButton buttonType="button" btnText="Send To Vendor"
                                handleSubmit={() => handleSubmit(
                                    { interpreter_id: item?.interpreter_id },
                                    "assign-vendor",
                                    () => console.log("Appointment accepted successfully!")
                                )}/>
                            )} */}
                            {checkPermission('Invite Interpreter') && !item?.vendor_id && (
                                <SubmitButton buttonType="button" className={'green'} btnText="Invite Interpreters" handleSubmit={navigateToInviteInterpreter} />
                            )}
                            {!item?.vendor_id && item?.type !== '2' && item?.status !== 'assigned' &&(
                                <SubmitButton
                                    buttonType="button"
                                    btnText="Send To Excel"
                                    handleSubmit={() => handleSubmit(
                                        { interpreter_id: item?.interpreter_id },
                                        "assign-vendor",
                                        () => console.log("Appointment accepted successfully!"),
                                        "Are you sure you want to send this appointment to vendor?"
                                    )}
                                />
                            )}
                        </>
                    )}
                </div>

                <ViewTable item={item} />
                <div className='d-flex gap-2 justify-content-start mt-3'>
                    
                    {/* {checkPermission('Delete Appointments') &&
                        <SubmitButton buttonType="button" className={'tomatoRed'} btnText="Remove this Appointment" handleSubmit={handleRemove} />
                    } */}
                </div>
            </div>


            <div className="card_table p-4">
                <div className="row_main_head mb-3">
                    <h2 className={`main_heading`}>Appointment Logs</h2>
                </div>
                <LogsTable logs={logs} />
            </div>



            <SelectInterpreterModal
                isOpen={assignInterpreter}
                onClose={handleCloseAssignInterpreter}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />

            <CancelModal
                isOpen={cancelModal}
                onClose={handleCloseCancel}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <DonotCover
                isOpen={donotCover}
                onClose={handleCloseDonotCover}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <AddPatient
                isOpen={addPatient}
                onClose={handleCloseAddPatient}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <CouldNotCover
                isOpen={couldNotCover}
                onClose={handleCloseCouldNotCover}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />

            <RescheduleModal
                isOpen={rescheduleModal}
                onClose={handleCloseReschedule}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />

            <CheckinCheckoutAdjustmentModal
                isOpen={checkinCheckoutModal}
                handleClose={handleCloseCheckinCheckoutModal}
                onConfirm={handleSubmit}
                appointmentId={id}
                onSubmit={handleSubmit}
                item={item}
                loader={loading}
            />
            <ApprovalModal
                isOpen={approval}
                onClose={handleCloseApproval}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
        </div>
    )
}





export default AppointmentView